export const requestHostInterceptor = () => async action => {
  return {
    ...action,
    endpoint: action.endpoint,
  };
};
